export default {
    countryList: [
        {
            'id': 3,
            'name': 'Afghanistan',
            'code': 'AF',
            'slug': 'afghanistan'
        },
        {
            'id': 15,
            'name': 'Aland Islands',
            'code': 'AX',
            'slug': 'aland-islands'
        },
        {
            'id': 6,
            'name': 'Albania',
            'code': 'AL',
            'slug': 'albania'
        },
        {
            'id': 62,
            'name': 'Algeria',
            'code': 'DZ',
            'slug': 'algeria'
        },
        {
            'id': 1,
            'name': 'Andorra',
            'code': 'AD',
            'slug': 'andorra'
        },
        {
            'id': 8,
            'name': 'Angola',
            'code': 'AO',
            'slug': 'angola'
        },
        {
            'id': 5,
            'name': 'Anguilla',
            'code': 'AI',
            'slug': 'anguilla'
        },
        {
            'id': 9,
            'name': 'Antarctica',
            'code': 'AQ',
            'slug': 'antarctica'
        },
        {
            'id': 4,
            'name': 'Antigua and Barbuda',
            'code': 'AG',
            'slug': 'antigua-and-barbuda'
        },
        {
            'id': 10,
            'name': 'Argentina',
            'code': 'AR',
            'slug': 'argentina'
        },
        {
            'id': 7,
            'name': 'Armenia',
            'code': 'AM',
            'slug': 'armenia'
        },
        {
            'id': 14,
            'name': 'Aruba',
            'code': 'AW',
            'slug': 'aruba'
        },
        {
            'id': 13,
            'name': 'Australia',
            'code': 'AU',
            'slug': 'australia'
        },
        {
            'id': 12,
            'name': 'Austria',
            'code': 'AT',
            'slug': 'austria'
        },
        {
            'id': 16,
            'name': 'Azerbaijan',
            'code': 'AZ',
            'slug': 'azerbaijan'
        },
        {
            'id': 32,
            'name': 'Bahamas',
            'code': 'BS',
            'slug': 'bahamas'
        },
        {
            'id': 23,
            'name': 'Bahrain',
            'code': 'BH',
            'slug': 'bahrain'
        },
        {
            'id': 19,
            'name': 'Bangladesh',
            'code': 'BD',
            'slug': 'bangladesh'
        },
        {
            'id': 18,
            'name': 'Barbados',
            'code': 'BB',
            'slug': 'barbados'
        },
        {
            'id': 36,
            'name': 'Belarus',
            'code': 'BY',
            'slug': 'belarus'
        },
        {
            'id': 20,
            'name': 'Belgium',
            'code': 'BE',
            'slug': 'belgium'
        },
        {
            'id': 37,
            'name': 'Belize',
            'code': 'BZ',
            'slug': 'belize'
        },
        {
            'id': 25,
            'name': 'Benin',
            'code': 'BJ',
            'slug': 'benin'
        },
        {
            'id': 27,
            'name': 'Bermuda',
            'code': 'BM',
            'slug': 'bermuda'
        },
        {
            'id': 33,
            'name': 'Bhutan',
            'code': 'BT',
            'slug': 'bhutan'
        },
        {
            'id': 29,
            'name': 'Bolivia',
            'code': 'BO',
            'slug': 'bolivia'
        },
        {
            'id': 30,
            'name': 'Bonaire, Sint Eustatius and Saba',
            'code': 'BQ',
            'slug': 'bonaire-sint-eustatius-and-saba'
        },
        {
            'id': 17,
            'name': 'Bosnia and Herzegovina',
            'code': 'BA',
            'slug': 'bosnia-and-herzegovina'
        },
        {
            'id': 35,
            'name': 'Botswana',
            'code': 'BW',
            'slug': 'botswana'
        },
        {
            'id': 34,
            'name': 'Bouvet Island',
            'code': 'BV',
            'slug': 'bouvet-island'
        },
        {
            'id': 31,
            'name': 'Brazil',
            'code': 'BR',
            'slug': 'brazil'
        },
        {
            'id': 106,
            'name': 'British Indian Ocean Territory',
            'code': 'IO',
            'slug': 'british-indian-ocean-territory'
        },
        {
            'id': 28,
            'name': 'Brunei Darussalam',
            'code': 'BN',
            'slug': 'brunei'
        },
        {
            'id': 22,
            'name': 'Bulgaria',
            'code': 'BG',
            'slug': 'bulgaria'
        },
        {
            'id': 21,
            'name': 'Burkina Faso',
            'code': 'BF',
            'slug': 'burkina-faso'
        },
        {
            'id': 24,
            'name': 'Burundi',
            'code': 'BI',
            'slug': 'burundi'
        },
        {
            'id': 117,
            'name': 'Cambodia',
            'code': 'KH',
            'slug': 'cambodia'
        },
        {
            'id': 47,
            'name': 'Cameroon',
            'code': 'CM',
            'slug': 'cameroon'
        },
        {
            'id': 38,
            'name': 'Canada',
            'code': 'CA',
            'slug': 'canada'
        },
        {
            'id': 260,
            'name': 'Cape Verde',
            'code': 'CV',
            'slug': 'cape-verde'
        },
        {
            'id': 125,
            'name': 'Cayman Islands',
            'code': 'KY',
            'slug': 'cayman-islands'
        },
        {
            'id': 41,
            'name': 'Central African Republic',
            'code': 'CF',
            'slug': 'central-african-republic'
        },
        {
            'id': 216,
            'name': 'Chad',
            'code': 'TD',
            'slug': 'chad'
        },
        {
            'id': 46,
            'name': 'Chile',
            'code': 'CL',
            'slug': 'chile'
        },
        {
            'id': 48,
            'name': 'China',
            'code': 'CN',
            'slug': 'china'
        },
        {
            'id': 54,
            'name': 'Christmas Island',
            'code': 'CX',
            'slug': 'christmas-island'
        },
        {
            'id': 39,
            'name': 'Cocos (Keeling) Islands',
            'code': 'CC',
            'slug': 'cocos-islands'
        },
        {
            'id': 49,
            'name': 'Colombia',
            'code': 'CO',
            'slug': 'colombia'
        },
        {
            'id': 119,
            'name': 'Comoros',
            'code': 'KM',
            'slug': 'comoros'
        },
        {
            'id': 45,
            'name': 'Cook Islands',
            'code': 'CK',
            'slug': 'cook-islands'
        },
        {
            'id': 50,
            'name': 'Costa Rica',
            'code': 'CR',
            'slug': 'costa-rica'
        },
        {
            'id': 98,
            'name': 'Croatia',
            'code': 'HR',
            'slug': 'croatia'
        },
        {
            'id': 51,
            'name': 'Cuba',
            'code': 'CU',
            'slug': 'cuba'
        },
        {
            'id': 53,
            'name': 'Curaçao',
            'code': 'CW',
            'slug': 'curacao'
        },
        {
            'id': 55,
            'name': 'Cyprus',
            'code': 'CY',
            'slug': 'cyprus'
        },
        {
            'id': 56,
            'name': 'Czech Republic',
            'code': 'CZ',
            'slug': 'czechia'
        },
        {
            'id': 40,
            'name': 'Congo, the Democratic Republic of the',
            'code': 'CD',
            'slug': 'democratic-republic-of-the-congo'
        },
        {
            'id': 59,
            'name': 'Denmark',
            'code': 'DK',
            'slug': 'denmark'
        },
        {
            'id': 58,
            'name': 'Djibouti',
            'code': 'DJ',
            'slug': 'djibouti'
        },
        {
            'id': 60,
            'name': 'Dominica',
            'code': 'DM',
            'slug': 'dominica'
        },
        {
            'id': 61,
            'name': 'Dominican Republic',
            'code': 'DO',
            'slug': 'dominican-republic'
        },
        {
            'id': 63,
            'name': 'Ecuador',
            'code': 'EC',
            'slug': 'ecuador'
        },
        {
            'id': 65,
            'name': 'Egypt',
            'code': 'EG',
            'slug': 'egypt'
        },
        {
            'id': 211,
            'name': 'El Salvador',
            'code': 'SV',
            'slug': 'el-salvador'
        },
        {
            'id': 88,
            'name': 'Equatorial Guinea',
            'code': 'GQ',
            'slug': 'equatorial-guinea'
        },
        {
            'id': 67,
            'name': 'Eritrea',
            'code': 'ER',
            'slug': 'eritrea'
        },
        {
            'id': 64,
            'name': 'Estonia',
            'code': 'EE',
            'slug': 'estonia'
        },
        {
            'id': 214,
            'name': 'Eswatini',
            'code': 'SZ',
            'slug': 'eswatini'
        },
        {
            'id': 69,
            'name': 'Ethiopia',
            'code': 'ET',
            'slug': 'ethiopia'
        },
        {
            'id': 72,
            'name': 'Falkland Islands (Malvinas)',
            'code': 'FK',
            'slug': 'falkland-islands'
        },
        {
            'id': 74,
            'name': 'Faroe Islands',
            'code': 'FO',
            'slug': 'faroe-islands'
        },
        {
            'id': 71,
            'name': 'Fiji',
            'code': 'FJ',
            'slug': 'fiji'
        },
        {
            'id': 70,
            'name': 'Finland',
            'code': 'FI',
            'slug': 'finland'
        },
        {
            'id': 75,
            'name': 'France',
            'code': 'FR',
            'slug': 'france'
        },
        {
            'id': 80,
            'name': 'French Guiana',
            'code': 'GF',
            'slug': 'french-guiana'
        },
        {
            'id': 176,
            'name': 'French Polynesia',
            'code': 'PF',
            'slug': 'french-polynesia'
        },
        {
            'id': 217,
            'name': 'French Southern Territories',
            'code': 'TF',
            'slug': 'french-southern-territories'
        },
        {
            'id': 76,
            'name': 'Gabon',
            'code': 'GA',
            'slug': 'gabon'
        },
        {
            'id': 85,
            'name': 'Gambia, The',
            'code': 'GM',
            'slug': 'gambia'
        },
        {
            'id': 79,
            'name': 'Georgia',
            'code': 'GE',
            'slug': 'georgia'
        },
        {
            'id': 57,
            'name': 'Germany',
            'code': 'DE',
            'slug': 'germany'
        },
        {
            'id': 82,
            'name': 'Ghana',
            'code': 'GH',
            'slug': 'ghana'
        },
        {
            'id': 83,
            'name': 'Gibraltar',
            'code': 'GI',
            'slug': 'gibraltar'
        },
        {
            'id': 89,
            'name': 'Greece',
            'code': 'GR',
            'slug': 'greece'
        },
        {
            'id': 84,
            'name': 'Greenland',
            'code': 'GL',
            'slug': 'greenland'
        },
        {
            'id': 78,
            'name': 'Grenada',
            'code': 'GD',
            'slug': 'grenada'
        },
        {
            'id': 87,
            'name': 'Guadeloupe',
            'code': 'GP',
            'slug': 'guadeloupe'
        },
        {
            'id': 91,
            'name': 'Guatemala',
            'code': 'GT',
            'slug': 'guatemala'
        },
        {
            'id': 81,
            'name': 'Guernsey',
            'code': 'GG',
            'slug': 'guernsey'
        },
        {
            'id': 86,
            'name': 'Guinea',
            'code': 'GN',
            'slug': 'guinea'
        },
        {
            'id': 93,
            'name': 'Guinea-Bissau',
            'code': 'GW',
            'slug': 'guinea-bissau'
        },
        {
            'id': 94,
            'name': 'Guyana',
            'code': 'GY',
            'slug': 'guyana'
        },
        {
            'id': 99,
            'name': 'Haiti',
            'code': 'HT',
            'slug': 'haiti'
        },
        {
            'id': 96,
            'name': 'Heard Island and McDonald Islands',
            'code': 'HM',
            'slug': 'heard-island-and-mcdonald-islands'
        },
        {
            'id': 97,
            'name': 'Honduras',
            'code': 'HN',
            'slug': 'honduras'
        },
        {
            'id': 95,
            'name': 'Hong Kong',
            'code': 'HK',
            'slug': 'hong-kong'
        },
        {
            'id': 100,
            'name': 'Hungary',
            'code': 'HU',
            'slug': 'hungary'
        },
        {
            'id': 109,
            'name': 'Iceland',
            'code': 'IS',
            'slug': 'iceland'
        },
        {
            'id': 105,
            'name': 'India',
            'code': 'IN',
            'slug': 'india'
        },
        {
            'id': 101,
            'name': 'Indonesia',
            'code': 'ID',
            'slug': 'indonesia'
        },
        {
            'id': 108,
            'name': 'Iran',
            'code': 'IR',
            'slug': 'iran'
        },
        {
            'id': 107,
            'name': 'Iraq',
            'code': 'IQ',
            'slug': 'iraq'
        },
        {
            'id': 102,
            'name': 'Ireland',
            'code': 'IE',
            'slug': 'ireland'
        },
        {
            'id': 104,
            'name': 'Isle of Man',
            'code': 'IM',
            'slug': 'isle-of-man'
        },
        {
            'id': 103,
            'name': 'Israel',
            'code': 'IL',
            'slug': 'israel'
        },
        {
            'id': 110,
            'name': 'Italy',
            'code': 'IT',
            'slug': 'italy'
        },
        {
            'id': 44,
            'name': 'Cote d\'Ivoire',
            'code': 'CI',
            'slug': 'ivory-coast'
        },
        {
            'id': 112,
            'name': 'Jamaica',
            'code': 'JM',
            'slug': 'jamaica'
        },
        {
            'id': 114,
            'name': 'Japan',
            'code': 'JP',
            'slug': 'japan'
        },
        {
            'id': 111,
            'name': 'Jersey',
            'code': 'JE',
            'slug': 'jersey'
        },
        {
            'id': 113,
            'name': 'Jordan',
            'code': 'JO',
            'slug': 'jordan'
        },
        {
            'id': 126,
            'name': 'Kazakhstan',
            'code': 'KZ',
            'slug': 'kazakhstan'
        },
        {
            'id': 115,
            'name': 'Kenya',
            'code': 'KE',
            'slug': 'kenya'
        },
        {
            'id': 118,
            'name': 'Kiribati',
            'code': 'KI',
            'slug': 'kiribati'
        },
        {
            'id': 123,
            'name': 'Kosovo',
            'code': 'XK',
            'slug': 'kosovo'
        },
        {
            'id': 124,
            'name': 'Kuwait',
            'code': 'KW',
            'slug': 'kuwait'
        },
        {
            'id': 116,
            'name': 'Kyrgyzstan',
            'code': 'KG',
            'slug': 'kyrgyzstan'
        },
        {
            'id': 127,
            'name': 'Lao People\'s Democratic Republic',
            'code': 'LA',
            'slug': 'laos'
        },
        {
            'id': 136,
            'name': 'Latvia',
            'code': 'LV',
            'slug': 'latvia'
        },
        {
            'id': 128,
            'name': 'Lebanon',
            'code': 'LB',
            'slug': 'lebanon'
        },
        {
            'id': 133,
            'name': 'Lesotho',
            'code': 'LS',
            'slug': 'lesotho'
        },
        {
            'id': 132,
            'name': 'Liberia',
            'code': 'LR',
            'slug': 'liberia'
        },
        {
            'id': 137,
            'name': 'Libya',
            'code': 'LY',
            'slug': 'libya'
        },
        {
            'id': 130,
            'name': 'Liechtenstein',
            'code': 'LI',
            'slug': 'liechtenstein'
        },
        {
            'id': 134,
            'name': 'Lithuania',
            'code': 'LT',
            'slug': 'lithuania'
        },
        {
            'id': 135,
            'name': 'Luxembourg',
            'code': 'LU',
            'slug': 'luxembourg'
        },
        {
            'id': 149,
            'name': 'Macao',
            'code': 'MO',
            'slug': 'macao'
        },
        {
            'id': 143,
            'name': 'Madagascar',
            'code': 'MG',
            'slug': 'madagascar'
        },
        {
            'id': 157,
            'name': 'Malawi',
            'code': 'MW',
            'slug': 'malawi'
        },
        {
            'id': 159,
            'name': 'Malaysia',
            'code': 'MY',
            'slug': 'malaysia'
        },
        {
            'id': 156,
            'name': 'Maldives',
            'code': 'MV',
            'slug': 'maldives'
        },
        {
            'id': 146,
            'name': 'Mali',
            'code': 'ML',
            'slug': 'mali'
        },
        {
            'id': 154,
            'name': 'Malta',
            'code': 'MT',
            'slug': 'malta'
        },
        {
            'id': 151,
            'name': 'Martinique',
            'code': 'MQ',
            'slug': 'martinique'
        },
        {
            'id': 152,
            'name': 'Mauritania',
            'code': 'MR',
            'slug': 'mauritania'
        },
        {
            'id': 155,
            'name': 'Mauritius',
            'code': 'MU',
            'slug': 'mauritius'
        },
        {
            'id': 247,
            'name': 'Mayotte',
            'code': 'YT',
            'slug': 'mayotte'
        },
        {
            'id': 158,
            'name': 'Mexico',
            'code': 'MX',
            'slug': 'mexico'
        },
        {
            'id': 140,
            'name': 'Moldova',
            'code': 'MD',
            'slug': 'moldova'
        },
        {
            'id': 139,
            'name': 'Monaco',
            'code': 'MC',
            'slug': 'monaco'
        },
        {
            'id': 148,
            'name': 'Mongolia',
            'code': 'MN',
            'slug': 'mongolia'
        },
        {
            'id': 141,
            'name': 'Montenegro',
            'code': 'ME',
            'slug': 'montenegro'
        },
        {
            'id': 153,
            'name': 'Montserrat',
            'code': 'MS',
            'slug': 'montserrat'
        },
        {
            'id': 138,
            'name': 'Morocco',
            'code': 'MA',
            'slug': 'morocco'
        },
        {
            'id': 160,
            'name': 'Mozambique',
            'code': 'MZ',
            'slug': 'mozambique'
        },
        {
            'id': 147,
            'name': 'Myanmar',
            'code': 'MM',
            'slug': 'myanmar'
        },
        {
            'id': 161,
            'name': 'Namibia',
            'code': 'NA',
            'slug': 'namibia'
        },
        {
            'id': 170,
            'name': 'Nauru',
            'code': 'NR',
            'slug': 'nauru'
        },
        {
            'id': 169,
            'name': 'Nepal',
            'code': 'NP',
            'slug': 'nepal'
        },
        {
            'id': 167,
            'name': 'Netherlands',
            'code': 'NL',
            'slug': 'netherlands'
        },
        {
            'id': 162,
            'name': 'New Caledonia',
            'code': 'NC',
            'slug': 'new-caledonia'
        },
        {
            'id': 172,
            'name': 'New Zealand',
            'code': 'NZ',
            'slug': 'new-zealand'
        },
        {
            'id': 166,
            'name': 'Nicaragua',
            'code': 'NI',
            'slug': 'nicaragua'
        },
        {
            'id': 163,
            'name': 'Niger',
            'code': 'NE',
            'slug': 'niger'
        },
        {
            'id': 165,
            'name': 'Nigeria',
            'code': 'NG',
            'slug': 'nigeria'
        },
        {
            'id': 171,
            'name': 'Niue',
            'code': 'NU',
            'slug': 'niue'
        },
        {
            'id': 164,
            'name': 'Norfolk Island',
            'code': 'NF',
            'slug': 'norfolk-island'
        },
        {
            'id': 121,
            'name': 'Korea, Democratic People\'s Republic of',
            'code': 'KP',
            'slug': 'north-korea'
        },
        {
            'id': 145,
            'name': 'Macedonia, the former Yugoslav Republic of',
            'code': 'MK',
            'slug': 'north-macedonia'
        },
        {
            'id': 168,
            'name': 'Norway',
            'code': 'NO',
            'slug': 'norway'
        },
        {
            'id': 173,
            'name': 'Oman',
            'code': 'OM',
            'slug': 'oman'
        },
        {
            'id': 179,
            'name': 'Pakistan',
            'code': 'PK',
            'slug': 'pakistan'
        },
        {
            'id': 184,
            'name': 'Palestine',
            'code': 'PS',
            'slug': 'palestinian-territory'
        },
        {
            'id': 174,
            'name': 'Panama',
            'code': 'PA',
            'slug': 'panama'
        },
        {
            'id': 177,
            'name': 'Papua New Guinea',
            'code': 'PG',
            'slug': 'papua-new-guinea'
        },
        {
            'id': 187,
            'name': 'Paraguay',
            'code': 'PY',
            'slug': 'paraguay'
        },
        {
            'id': 175,
            'name': 'Peru',
            'code': 'PE',
            'slug': 'peru'
        },
        {
            'id': 178,
            'name': 'Philippines',
            'code': 'PH',
            'slug': 'philippines'
        },
        {
            'id': 182,
            'name': 'Pitcairn',
            'code': 'PN',
            'slug': 'pitcairn'
        },
        {
            'id': 180,
            'name': 'Poland',
            'code': 'PL',
            'slug': 'poland'
        },
        {
            'id': 185,
            'name': 'Portugal',
            'code': 'PT',
            'slug': 'portugal'
        },
        {
            'id': 188,
            'name': 'Qatar',
            'code': 'QA',
            'slug': 'qatar'
        },
        {
            'id': 42,
            'name': 'Congo',
            'code': 'CG',
            'slug': 'republic-of-the-congo'
        },
        {
            'id': 189,
            'name': 'Reunion',
            'code': 'RE',
            'slug': 'reunion'
        },
        {
            'id': 190,
            'name': 'Romania',
            'code': 'RO',
            'slug': 'romania'
        },
        {
            'id': 192,
            'name': 'Russian Federation',
            'code': 'RU',
            'slug': 'russia'
        },
        {
            'id': 193,
            'name': 'Rwanda',
            'code': 'RW',
            'slug': 'rwanda'
        },
        {
            'id': 26,
            'name': 'Saint Barthélemy',
            'code': 'BL',
            'slug': 'saint-barthelemy'
        },
        {
            'id': 201,
            'name': 'Saint Helena, Ascension and Tristan da Cunha',
            'code': 'SH',
            'slug': 'saint-helena'
        },
        {
            'id': 120,
            'name': 'Saint Kitts and Nevis',
            'code': 'KN',
            'slug': 'saint-kitts-and-nevis'
        },
        {
            'id': 129,
            'name': 'Saint Lucia',
            'code': 'LC',
            'slug': 'saint-lucia'
        },
        {
            'id': 142,
            'name': 'Saint Martin (French part)',
            'code': 'MF',
            'slug': 'saint-martin'
        },
        {
            'id': 181,
            'name': 'Saint Pierre and Miquelon',
            'code': 'PM',
            'slug': 'saint-pierre-and-miquelon'
        },
        {
            'id': 238,
            'name': 'Saint Vincent and the Grenadines',
            'code': 'VC',
            'slug': 'saint-vincent-and-the-grenadines'
        },
        {
            'id': 245,
            'name': 'Samoa',
            'code': 'WS',
            'slug': 'samoa'
        },
        {
            'id': 206,
            'name': 'San Marino',
            'code': 'SM',
            'slug': 'san-marino'
        },
        {
            'id': 210,
            'name': 'Sao Tome and Principe',
            'code': 'ST',
            'slug': 'sao-tome-and-principe'
        },
        {
            'id': 194,
            'name': 'Saudi Arabia',
            'code': 'SA',
            'slug': 'saudi-arabia'
        },
        {
            'id': 207,
            'name': 'Senegal',
            'code': 'SN',
            'slug': 'senegal'
        },
        {
            'id': 191,
            'name': 'Serbia',
            'code': 'RS',
            'slug': 'serbia'
        },
        {
            'id': 196,
            'name': 'Seychelles',
            'code': 'SC',
            'slug': 'seychelles'
        },
        {
            'id': 205,
            'name': 'Sierra Leone',
            'code': 'SL',
            'slug': 'sierra-leone'
        },
        {
            'id': 200,
            'name': 'Singapore',
            'code': 'SG',
            'slug': 'singapore'
        },
        {
            'id': 212,
            'name': 'Sint Maarten (Dutch part)',
            'code': 'SX',
            'slug': 'sint-maarten'
        },
        {
            'id': 204,
            'name': 'Slovakia',
            'code': 'SK',
            'slug': 'slovakia'
        },
        {
            'id': 202,
            'name': 'Slovenia',
            'code': 'SI',
            'slug': 'slovenia'
        },
        {
            'id': 195,
            'name': 'Solomon Islands',
            'code': 'SB',
            'slug': 'solomon-islands'
        },
        {
            'id': 208,
            'name': 'Somalia',
            'code': 'SO',
            'slug': 'somalia'
        },
        {
            'id': 248,
            'name': 'South Africa',
            'code': 'ZA',
            'slug': 'south-africa'
        },
        {
            'id': 90,
            'name': 'South Georgia and the South Sandwich Islands',
            'code': 'GS',
            'slug': 'south-georgia-and-the-south-sandwich-islands'
        },
        {
            'id': 122,
            'name': 'Korea, Republic of',
            'code': 'KR',
            'slug': 'south-korea'
        },
        {
            'id': 198,
            'name': 'South Sudan',
            'code': 'SS',
            'slug': 'south-sudan'
        },
        {
            'id': 68,
            'name': 'Spain',
            'code': 'ES',
            'slug': 'spain'
        },
        {
            'id': 131,
            'name': 'Sri Lanka',
            'code': 'LK',
            'slug': 'sri-lanka'
        },
        {
            'id': 197,
            'name': 'Sudan',
            'code': 'SD',
            'slug': 'sudan'
        },
        {
            'id': 209,
            'name': 'Suriname',
            'code': 'SR',
            'slug': 'suriname'
        },
        {
            'id': 203,
            'name': 'Svalbard and Jan Mayen',
            'code': 'SJ',
            'slug': 'svalbard-and-jan-mayen'
        },
        {
            'id': 199,
            'name': 'Sweden',
            'code': 'SE',
            'slug': 'sweden'
        },
        {
            'id': 43,
            'name': 'Switzerland',
            'code': 'CH',
            'slug': 'switzerland'
        },
        {
            'id': 213,
            'name': 'Syrian Arab Republic',
            'code': 'SY',
            'slug': 'syria'
        },
        {
            'id': 229,
            'name': 'Taiwan',
            'code': 'TW',
            'slug': 'taiwan'
        },
        {
            'id': 220,
            'name': 'Tajikistan',
            'code': 'TJ',
            'slug': 'tajikistan'
        },
        {
            'id': 230,
            'name': 'Tanzania, United Republic of',
            'code': 'TZ',
            'slug': 'tanzania'
        },
        {
            'id': 219,
            'name': 'Thailand',
            'code': 'TH',
            'slug': 'thailand'
        },
        {
            'id': 222,
            'name': 'Timor-Leste',
            'code': 'TL',
            'slug': 'timor-leste'
        },
        {
            'id': 218,
            'name': 'Togo',
            'code': 'TG',
            'slug': 'togo'
        },
        {
            'id': 221,
            'name': 'Tokelau',
            'code': 'TK',
            'slug': 'tokelau'
        },
        {
            'id': 225,
            'name': 'Tonga',
            'code': 'TO',
            'slug': 'tonga'
        },
        {
            'id': 227,
            'name': 'Trinidad and Tobago',
            'code': 'TT',
            'slug': 'trinidad-and-tobago'
        },
        {
            'id': 224,
            'name': 'Tunisia',
            'code': 'TN',
            'slug': 'tunisia'
        },
        {
            'id': 226,
            'name': 'Turkey',
            'code': 'TR',
            'slug': 'turkey'
        },
        {
            'id': 223,
            'name': 'Turkmenistan',
            'code': 'TM',
            'slug': 'turkmenistan'
        },
        {
            'id': 215,
            'name': 'Turks and Caicos Islands',
            'code': 'TC',
            'slug': 'turks-and-caicos-islands'
        },
        {
            'id': 228,
            'name': 'Tuvalu',
            'code': 'TV',
            'slug': 'tuvalu'
        },
        {
            'id': 232,
            'name': 'Uganda',
            'code': 'UG',
            'slug': 'uganda'
        },
        {
            'id': 231,
            'name': 'Ukraine',
            'code': 'UA',
            'slug': 'ukraine'
        },
        {
            'id': 2,
            'name': 'United Arab Emirates',
            'code': 'AE',
            'slug': 'united-arab-emirates'
        },
        {
            'id': 77,
            'name': 'United Kingdom',
            'code': 'GB',
            'slug': 'united-kingdom'
        },
        {
            'id': 234,
            'name': 'United States',
            'code': 'US',
            'slug': 'united-states'
        },
        {
            'id': 235,
            'name': 'Uruguay',
            'code': 'UY',
            'slug': 'uruguay'
        },
        {
            'id': 236,
            'name': 'Uzbekistan',
            'code': 'UZ',
            'slug': 'uzbekistan'
        },
        {
            'id': 243,
            'name': 'Vanuatu',
            'code': 'VU',
            'slug': 'vanuatu'
        },
        {
            'id': 237,
            'name': 'Holy See (Vatican City State)',
            'code': 'VA',
            'slug': 'vatican'
        },
        {
            'id': 239,
            'name': 'Venezuela, Bolivarian Republic of',
            'code': 'VE',
            'slug': 'venezuela'
        },
        {
            'id': 242,
            'name': 'Vietnam',
            'code': 'VN',
            'slug': 'vietnam'
        },
        {
            'id': 264,
            'name': 'Virgin Islands, British',
            'code': 'VG',
            'slug': 'virgin-islands'
        },
        {
            'id': 244,
            'name': 'Wallis and Futuna',
            'code': 'WF',
            'slug': 'wallis-and-futuna'
        },
        {
            'id': 66,
            'name': 'Western Sahara',
            'code': 'EH',
            'slug': 'western-sahara'
        },
        {
            'id': 246,
            'name': 'Yemen',
            'code': 'YE',
            'slug': 'yemen'
        },
        {
            'id': 249,
            'name': 'Zambia',
            'code': 'ZM',
            'slug': 'zambia'
        },
        {
            'id': 250,
            'name': 'Zimbabwe',
            'code': 'ZW',
            'slug': 'zimbabwe'
        }
    ]
};
